export const STATUS_TYPE = {
  0: { text: '已提交', color: 'info', order: 1 },
  1: { text: '已处理', color: 'success', order: 3 }
};

export const TICKET_TYPE = {
  0: '找回密码',
  1: '其他'
};
